import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';

// Toast import
import { Toaster, toast } from 'react-hot-toast';

// Context import - YENİ
import { ConfirmModalProvider } from './contexts/ConfirmModalContext';

// Components
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import AdminPanel from './components/AdminPanel/AdminPanel';

// Config
import API_URL, { AUTH_URL, BASE_URL } from './config';

// Axios interceptor setup
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      toast.error('Oturum süreniz doldu. Lütfen tekrar giriş yapın.');
      
      if (!error.config.url.includes('/auth/')) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        
        const response = await axios.get(`${AUTH_URL}/me`);
        setCurrentUser(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Token geçersiz:', error);
        handleLogout();
      }
    }
    setLoading(false);
  };

  const handleLogin = (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setCurrentUser(user);
    setIsAuthenticated(true);
    
    toast.success(`Hoş geldiniz, ${user.username}!`);
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${AUTH_URL}/logout`);
      toast.success('Güvenli çıkış yapıldı');
    } catch (error) {
      console.error('Logout hatası:', error);
    }
    
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    
    setIsAuthenticated(false);
    setCurrentUser(null);
  };


  return (
    <ConfirmModalProvider>
      {/* Toast Container */}
      <Toaster
        position="bottom-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '10px',
            padding: '16px',
            fontSize: '14px',
          },
          
          success: {
            duration: 3000,
            style: {
              background: '#10B981',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#10B981',
            },
          },
          
          error: {
            duration: 5000,
            style: {
              background: '#EF4444',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#EF4444',
            },
          },
          
          loading: {
            style: {
              background: '#6366F1',
            },
          },
        }}
      />
      
      <Router>
        <Routes>
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
                <Navigate to="/" replace /> : 
                <Login onLogin={handleLogin} />
            } 
          />

          <Route 
            path="/" 
            element={
              isAuthenticated ? 
                <Dashboard 
                  user={currentUser} 
                  onLogout={handleLogout}
                /> : 
                <Navigate to="/login" replace />
            } 
          />

          <Route 
            path="/admin" 
            element={
              isAuthenticated && currentUser?.role === 'root' ? 
                <AdminPanel 
                  user={currentUser} 
                  onLogout={handleLogout}
                /> : 
                <Navigate to="/" replace />
            } 
          />

          <Route path="*" element={<Navigate to="/" replace />} />
          
        </Routes>
      </Router>
    </ConfirmModalProvider>
  );
}

export default App; 